import apiEndpoints from './apiEndpoints';
import { getRequest, replaceInUrl } from './index';

export const getDropoffLocations = ({ addressUid }) =>
  getRequest(apiEndpoints.shippings.dropoffLocations, { addressUid });

export const getSfhPurchaseLabel = ({ brokerCode, orderCode }) =>
  getRequest(
    replaceInUrl(apiEndpoints.shippings.purchaseLabel, {
      brokerCode,
      orderCode,
    }),
  );
